import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import styles from './IconAction.module.css';

/** Ação compacta de linha: ícone redondo com tooltip. */
function IconAction({ title, onClick, tone = 'neutral', disabled = false, children }) {
  return (
    <Tooltip title={title} arrow>
      <span>
        <button
          type="button"
          className={`${styles.button} ${styles[tone] || ''}`}
          onClick={onClick}
          disabled={disabled}
          aria-label={title}
        >
          {children}
        </button>
      </span>
    </Tooltip>
  );
}

/** Par WhatsApp + ligar, o mais comum nas listas do Início. */
export function ContactActions({ whatsappTitle, onWhatsApp, phone }) {
  return (
    <>
      <IconAction title={whatsappTitle} onClick={onWhatsApp} tone="whatsapp">
        <WhatsAppIcon style={{ fontSize: 17 }} />
      </IconAction>
      <IconAction title="Ligar" onClick={() => { window.location.href = `tel:${phone}`; }}>
        <PhoneIcon style={{ fontSize: 16 }} />
      </IconAction>
    </>
  );
}

export default IconAction;
